import { render, staticRenderFns } from "./favMC.vue?vue&type=template&id=9cba0c5e"
import script from "./favMC.vue?vue&type=script&lang=js"
export * from "./favMC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports